import { Breadcrumb,Button,Form,Modal,Input,Spin,Popconfirm,message,Space,Select } from "antd";
import Header from "../../components/dashboard/header";
import {DashboardOutlined,PlusSquareOutlined,InboxOutlined} from "@ant-design/icons";
import {useState,useRef,useContext,useEffect} from "react"
import DataTable from "../../components/common/table";
import { Link, useNavigate } from "react-router-dom";
import RefreshContext from "../../context/refreshContext";
import { extractValueFromInputRef } from "../../helpers/dom";
import {TbFileSettings} from "react-icons/tb";
import { useFetchAllFinancialYears } from "../../hooks/financialYear/financialYearQuery";
import { useGetPayrollData, useInitializePayroll } from "../../hooks/payroll/payrollQuery";
import { MONTHS } from "../../defaults/utilities";
import PayrollConfiguration from "../../components/dashboard/payrollConfiguration";
import { hasPayrollAccess } from "../../helpers/roles";
import { userStore } from "../../store/userStore";


const {Option} = Select;



const NoDataComponent = ()=>{


    return(
        <>
            <div style={{
                display:"flex",
                flexDirection:"column",
                justifyContent:"center",
                alignItems:"center",
                marginTop:"3em",
                color:"gray",
                border:"1px solid lightgray",
                borderRadius:"4px",
                paddingTop:"2em",
                paddingBottom:"2em"
            }}>
                <div style={{
                }}>
                <InboxOutlined style={{
                    fontSize:"3rem"
                }}/>
                </div>
                No Data for selected Query
            </div>
        </>
    )
}





export default function PayrollConfig(){
    const navigate = useNavigate();
    const user = userStore(state => state.user);
    
    const [isOpen,setIsOpen] = useState(false);
    const [loading,setLoading] = useState(false);
    const [month,setMonth] = useState(null);
    const [year,setYear] = useState(null);
    const [m,setM] = useState(null);
    const [y,setY] = useState(null);
    const [data,setData] = useState({});

    const initializePayroll = useInitializePayroll();

    // Check access permissions
    useEffect(() => {
        if (user && !hasPayrollAccess(user.roles)) {
            message.error('You do not have permission to access this page');
            navigate('/dashboard');
        }
    }, [user, navigate]);


    const showCreateModal = ()=>setIsOpen(true);
    const hideCreateModal = ()=>setIsOpen(false);

    const getPayrolls = useGetPayrollData();

    const {years} = useFetchAllFinancialYears();

    const handleYearSearch = async(value)=>{
        setY(value);
        if(m){
            setLoading(true);
            const response = await getPayrolls(value,m);
            setLoading(false);
            console.log("search result",response.payrollConfig);
            setData({...response.payrollConfig});
        }
    }

    const handleMonthSearch = async(value)=>{
        setM(value);
        setLoading(true);
        const response = await getPayrolls(y,value);
        setLoading(false);
        console.log("search result",response);
        setData({...response.payrollConfig});
    }


    const handeleSubmit = async ()=>{
        const payload ={
            financialYear:year,
            month
        }
        await initializePayroll(payload);
        message.success("Payroll initialized successfully");
        setIsOpen(false);
    }



    return (
        <>
            <div className="main-container">
                <Header/>
                <div className="main-body">
                    <div className="info-bar">
                    <Breadcrumb>
                            <Breadcrumb.Item>
                            <DashboardOutlined className="dashboard-icon"/>
                            <Link to={"/dashboard"}>
                                Dashboard
                            </Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <TbFileSettings/>
                                <Link to="/dashboard/payroll-config">
                                    Payroll Configuration
                                </Link>
                            </Breadcrumb.Item>
                        </Breadcrumb>
                        <div>
                        <Select
                                showSearch
                                placeholder="Filter By Year"
                                onChange={handleYearSearch}
                                filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                style={{
                                width: 150,
                                }}
                                options={[...years.map(year=>({value:year.id,label:year.value}))]}
                            />
                        </div>
                        <div>
                        <Select
                                showSearch
                                placeholder="Filter By Month"
                                onChange={handleMonthSearch}
                                disabled={!y}
                                filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                style={{
                                width: 150,
                                }}
                                options={[...MONTHS.map(month=>({value:month.value,label:month.name}))]}
                            />
                        </div>
                        <div style={{display:'flex',gap:'1em'}}>
                        <Button disabled={ !y || !m} style={{backgroundColor:"green",color:"#FFFFFF"}} onClick={showCreateModal}>
                                <PlusSquareOutlined/>
                                Create Payroll
                            </Button>
                        </div>
                    </div>
                    <div className="table-section">
                        <Spin spinning={loading}>
                            {
                                Object.keys(data).length > 0 ?
                            <PayrollConfiguration config={data} onUpdate={handleMonthSearch}/>:
                                <NoDataComponent/>
                            }
                        </Spin>
                    </div>
                </div>
            </div>
            <div>
                <Modal title="Create Payroll" open={isOpen} footer={null} onCancel={hideCreateModal}>
                <div style={{marginTop:"3em",maxHeight:"70vh",overflowY:"scroll",paddingLeft:"1em",paddingRight:"1em"}}>
                    <Form wrapperCol={{
                                span: 24,
                              }}>
                                <Form.Item>
                                    <Select onChange={(e)=>setYear(e)} placeholder="Select Financial Year">
                                        {
                                            years.map((yr,idx)=>(
                                                <Option value={yr.id} key={idx}>{yr.title}</Option>
                                            ))
                                        }
                                    </Select>
                                </Form.Item>
                            <Form.Item>
                                <Select onChange={(e)=>setMonth(e)} placeholder="select month">
                                    {
                                        MONTHS.map((mon,idx)=>(
                                            <Option value={mon.value} key={idx}>{mon.name}</Option>
                                        ))
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item wrapperCol={{
                                span:8,
                                offset:20
                            }}>
                                <Button type="primary" onClick={handeleSubmit}>
                            Initialize
                        </Button>
                            </Form.Item>
                    </Form>
                </div>
                </Modal>
            </div>
        </>
    )
}
